/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI
 *
 * Copyright IBM Corp. 2017, 2021
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @file Controller to handle lasso related logic such as: lasso activation,
 * lasso co-oridinate provision etc.
 */

'use strict';

define([
	'../../../lib/@waca/core-client/js/core-client/ui/core/Events'
],function(Events) {

	var LassoController = Events.extend({

		/**
		 * @param {Object} options.targetElement element (jquery)
		 */
		init: function(options) {
			LassoController.inherited('init', this, arguments);
			this.targetElement = options.targetElement;
			this.cordinateResolver = options.cordinateResolver;
			this.isDragging =  options.isDragging;
			this.dashboard = options.dashboard;
		},

		_loadCss(href) {
			const head = document.getElementsByTagName('head')[0];
			const stylesheet = head.querySelectorAll(`[href='${href}']`);
			if (!stylesheet.length) {
				const link  = document.createElement('link');
				link.rel  = 'stylesheet';
				link.type = 'text/css';
				link.href = href;
				link.media = 'all';
				head.appendChild(link);
			}
		},

		_initViews() {
			if (!this._views) {
				this._views = {};
				const contributions = this.dashboard && this.dashboard.getFeature('Lasso').getContributions() || [];
				contributions.forEach(contribution => this._views[contribution.id] = contribution );
			}
		},

		/**
		 * Activate/Deactivate lasso selection mode
		 * @param {boolean} [state=false] - state of lasso mode. True activates and
		 * false deactivates the lasso mode. Defaults to false.
		 */
		activateLassoMode: function(state, viewId){
			var _state = state || false;
			if(_state) {
				this._initViews();
				const { module, css } = this._views[viewId] || this._views[LassoController.DEFAULT_VIEW_ID];
				if(css){
					this._loadCss(css);
				}
				this.view = new module(this.targetElement, this.cordinateResolver, this.isDragging);
				this.view.on('all', this._handleViewEvent, this);
			}else if (this.isLassoMode()) {
				this.view.off('all', this._handleViewEvent, this);
				this.view.remove();
				this.view = null;
			}
			return Promise.resolve();
		},

		/**
		 * @return True if lasso mode is active, false otherwise.
		 */
		isLassoMode: function () {
			return !!this.view;
		},

		/**
		* Handler view event
		*/
		_handleViewEvent: function(payload, eventName){
			this.trigger(eventName, payload);
		},

		getCoordinates() {
			return this.view && this.view.getCoordinates();
		},

		getCurrentViewId(){
			return this.view && this.view.getId();
		},

		remove: function(){
			this.activateLassoMode(false);
			LassoController.inherited('remove', this, arguments);
			this.targetElement = null;
		}
	});

	LassoController.DEFAULT_VIEW_ID = 'lw-lasso-select';

	return LassoController;
});
